import React from 'react';
import { Box, Typography } from '@mui/material';
import { useLocalization } from '../localization/LocalizationContext';

export const CopyrightFooter: React.FC = () => {
  const { t } = useLocalization();
  const currentYear = new Date().getFullYear();
  const copyrightText = t.copyright.text.replace('{year}', currentYear.toString());

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        zIndex: 1000,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          opacity: 0.7,
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          padding: '4px 8px',
          borderRadius: 1,
        }}
      >
        {copyrightText}{' '}
        <a
          href="https://cursor.sh"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'inherit', textDecoration: 'none', fontWeight: 'bold' }}
        >
          {t.copyright.cursor}
        </a>
        {' & '}
        <a
          href="https://claude.ai"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'inherit', textDecoration: 'none', fontWeight: 'bold' }}
        >
          Claude
        </a>
      </Typography>
    </Box>
  );
};
